import { render, staticRenderFns } from "./AdminSelectCustomerForm.vue?vue&type=template&id=6b0378ae&scoped=true"
import script from "./AdminSelectCustomerForm.vue?vue&type=script&lang=js"
export * from "./AdminSelectCustomerForm.vue?vue&type=script&lang=js"
import style0 from "./AdminSelectCustomerForm.vue?vue&type=style&index=0&id=6b0378ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0378ae",
  null
  
)

export default component.exports